import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { Observable } from 'rxjs';

@Injectable()
export class AppointmentService {
  private $api: string = '';

  constructor(private $ajax: AjaxService) {
    this.$api = $ajax.getAPIDomain();
  }

  /**
   * 예약 정보 획득
   */
  appointment(bmiNum: number, date: Date): Observable<any> {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();

    return this.$ajax.httpRequest(
      'GET',
      this.$api + `appointment/${bmiNum}/${year}-${month}-${day}`,
    );
  }

  /**
   * 센터 이벤트 정보 획득
   */
  centerEvent(bmiNum: number): Observable<any> {
    return this.$ajax.httpRequest(
      'GET',
      this.$api + `event/${bmiNum}`,
    );
  }
}
